import {localizePath} from '../i18n';
export const pageLoaders = {
    '/carte': () => import('../component/cardMenuPage/CardMenuPage'),
    '/galerie': () => import('../component/imageGalleryPage/ImageGalleryPage'),
    '/politique-confidentialite': () => import('../component/legalsPage/PoliticConfidentiality'),
    '/mentions-legales': () => import('../component/legalsPage/MentionsLegales'),
};

export function preloadPage(event: Event) {
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest('a');
    if (!anchor || anchor.origin !== window.location.origin) return;
    const connection = (navigator as Navigator & {connection?: {saveData?: boolean; effectiveType?: string}}).connection;
    if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType ?? '')) return;
    const load = pageLoaders[localizePath(anchor.pathname, 'fr') as keyof typeof pageLoaders];
    if (load) void load().catch(() => {});
}
